<template>
  <aside class="main-sidebar elevation-4 sidebar-dark-primary">
    <router-link :to="{ name: 'dashboard' }" class="brand-link text-center">
      <span class="brand-text font-weight-dark"> {{userConfig.company_name}}</span>
    </router-link>
    <div class="sidebar">
      <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image"><img :src="auth_user.avatar" class="img-circle elevation-2" alt="User Image"></div>
        <div class="info"><a href="#" class="d-block">{{auth_user.name}}</a></div>
      </div>
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-toggle="push-menu" data-widget="treeview" role="menu"
          data-accordion="true">
          <li class="nav-item">
            <router-link :to="{ name: 'vouchers' }"
              style="color:black;background-color:#d39e00;border-color:#d39e00;box-shadow:none" class="nav-link">
              <i class="nav-icon fa fa-qrcode"></i>
              <p>Vouchers</p>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'dashboard' }">
              <i class="nav-icon fa fa-tag fa-fw"></i>
              <p>Cupons</p>
            </router-link>
          </li>
          <li class="nav-item">
            <a @click="shareApp()" href="#" class="nav-link">
              <i class="nav-icon fa fa-users"></i>
              <p>Convidar amigos</p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
  export default {
    data() {
      return {
        order: [],
        oldOrder: [],
      }
    },
    mounted() {
      $('body').Layout('fixLayoutHeight');
      setTimeout(() => {
        if (this.$router.history._startLocation == '/login') {
          $('[data-widget="treeview"]').Treeview('init');
        }
      }, 300);
    },
    methods: {
      async shareApp() {
        const shareData = {
          title: this.userConfig.company_name,
          text: 'Learn web development on MDN!',
          url: window.url + '/' + this.userConfig.company_url
        }
        try {
          await navigator.share(shareData);        
        } catch (e) {
         console.log(`Error: ${e}`);
        }
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  .navbar-dark {
    border: 0 !important;
  }

  .sl-vue-tree {
    position: relative;
    cursor: default;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
  }

  .sl-vue-tree-root>.sl-vue-tree-nodes-list {
    overflow: visible;
    position: relative;
    padding-bottom: 4px;
  }

  .sl-vue-tree-selected>.sl-vue-tree-node-item {
    background-color: rgba(100, 100, 255, 0.5);
  }

  .sl-vue-tree-node-list {
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .sl-vue-tree-node-item {
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 7px;
  }

  .sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
    outline: 1px solid rgba(100, 100, 255, 0.5);
  }

  .sl-vue-tree-gap {
    width: 20px;
    min-height: 1px;
  }

  .sl-vue-tree-sidebar {
    margin-left: auto;
  }

  .sl-vue-tree-cursor {
    position: absolute;
    border: 1px solid rgba(100, 100, 255, 0.5);
    height: 1px;
    width: 100%;
  }

  .sl-vue-tree-drag-info {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0.5;
    margin-left: 20px;
    margin-bottom: 20px;
    padding: 5px 10px;
  }

  .contextmenu {
    position: absolute;
    background-color: white;
    color: black;
    border-radius: 2px;
    cursor: pointer;
  }

  .contextmenu>ul {
    padding: 10px;
  }

  .contextmenu>ul:hover {
    background-color: rgba(100, 100, 255, 0.5);
  }

  .last-event {
    color: white;
    background-color: rgba(100, 100, 255, 0.5);
    padding: 10px;
    border-radius: 2px;
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
</style>